import { render, staticRenderFns } from "./CurateVecDyn.vue?vue&type=template&id=10955750&scoped=true&"
import script from "./CurateVecDyn.vue?vue&type=script&lang=js&"
export * from "./CurateVecDyn.vue?vue&type=script&lang=js&"
import style0 from "./CurateVecDyn.vue?vue&type=style&index=0&id=10955750&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10955750",
  null
  
)

export default component.exports